<template>
    <div class="background">
        <router-view />
    </div>
</template>

<script>
    import config from '@/mixins/config'

    export default {
        mixins: [config]
    }
</script>

<style>
    * {
        font-family: 'RobotoRegular';
    }
    .background {
        background: url('~@/assets/background.png') no-repeat;
        background-position: center;
        background-size: cover;
        overflow: auto;
    }
    @font-face {
        font-family: "RobotoRegular";
        src: url("~@/assets/fonts/Roboto-Regular.ttf") format("trueType")
    }
    @font-face {
        font-family: "RobotoMedium";
        src: url("~@/assets/fonts/Roboto-Medium.ttf") format("trueType")
    }
    @font-face {
        font-family: "Comfortaa";
        src: url("~@/assets/fonts/Comfortaa-Regular.ttf") format("trueType")
    }
    @font-face {
        font-family: "RobotoBold";
        src: url("~@/assets/fonts/Roboto-Bold.ttf") format("trueType")
    }
</style>
